module.exports = __webpack_public_path__ + "img/name.5f326416.svg";